export default {
    workShifts: [],
    workShiftsTotal: 0,
    reports: [],
    couriers: [],
    currentShift: null,
    currentDivision: {},
    shiftProcessing: false,
    isShiftLoaded: false,

    isRKeeperHasError: false,
    rKeeperErrorText: '',
}
